<template>
  <div class="container">
    <!-- Logout button - only show when user is logged in -->
    <div v-if="userName" class="logout-section">
      <button @click="logout" class="logout-button">
        退出
      </button>
    </div>

    <!-- Name input section -->
    <div v-if="!userName" class="input-section">
      <input
        v-model="inputName"
        type="text"
        class="name-input"
        placeholder="请输入您的名字"
      >
      <button @click="saveName" class="confirm-button">确认</button>
    </div>

    <!-- Answer button section -->
    <div v-else class="answer-section">
      <div class="user-info">当前用户：{{ userName }}</div>
      <button
        @click="submitAnswer"
        :class="['answer-button', { 'disabled': !canAnswer }]"
        :disabled="!canAnswer"
      >
        抢答
      </button>
    </div>

    <!-- Ranking list -->
    <div v-if="fastestThree.length > 0" class="ranking-section">
      <h2>最快抢答者</h2>
      <ul class="ranking-list">
        <li v-for="(user, index) in fastestThree" :key="index" class="ranking-item">
          {{ index + 1 }}. {{ user.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      socket: null,
      fastestThree: [],
      userName: '',
      inputName: '',
      canAnswer: false
    };
  },
  created() {
    // Check for existing username in localStorage
    const savedName = localStorage.getItem('quizUserName');
    if (savedName) {
      this.userName = savedName;
      this.initializeWebSocket(); // Only initialize WebSocket if we have a username
    }
  },
  methods: {
    initializeWebSocket() {
      // Initialize WebSocket connection
      this.socket = new WebSocket('wss://ws.jixiangjiaoyu.com');

      this.socket.onopen = () => {
        console.log('WebSocket connected');
        // If we have a username, register it
        if (this.userName) {
          this.socket.send(JSON.stringify({
            type: 'register',
            role_name: this.userName,
            is_admin: localStorage.getItem('quizUserRole') === 'admin'
          }));
        }
      };

      this.socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        console.log('Received message:', message);

        switch (message.type) {
          case 'start':
            this.canAnswer = true;
            this.fastestThree = []; // 清空排名
            break;
          case 'stop':
            this.canAnswer = false;
            if (message.data && message.data.fastestThree) {
              this.fastestThree = message.data.fastestThree;
            }
            break;
          case 'state':
            this.canAnswer = message.data.isActive;
            this.fastestThree = message.data.fastestThree || [];
            break;
          case 'error':
            console.error(message.message);
            break;
        }
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    },
    saveName() {
      if (this.inputName.trim()) {
        this.userName = this.inputName.trim();
        localStorage.setItem('quizUserName', this.userName);
        this.initializeWebSocket();
      }
    },
    submitAnswer() {
      if (this.canAnswer && this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify({
          type: 'answer',
          role_name: this.userName
        }));
        // Disable the answer button after submitting
        this.canAnswer = false;
      }
    },
    logout() {
      // Clear local storage
      localStorage.removeItem('quizUserName');
      // Reset data
      this.userName = '';
      this.inputName = '';
      this.canAnswer = false;
      this.fastestThree = [];
      // Close WebSocket if it exists
      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7fa;
}

.input-section {
  width: 100%;
  max-width: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.name-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
}

.name-input:focus {
  border-color: #4299e1;
}

.confirm-button {
  width: 100%;
  padding: 12px;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirm-button:hover {
  background-color: #3182ce;
}

.answer-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 40px;
}

.user-info {
  font-size: 16px;
  color: #4a5568;
}

.answer-button {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #48bb78;
  color: white;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.answer-button:active {
  transform: scale(0.95);
}

.answer-button.disabled {
  background-color: #cbd5e0;
  cursor: not-allowed;
}

.ranking-section {
  margin-top: 40px;
  width: 100%;
  max-width: 300px;
}

.ranking-section h2 {
  color: #2d3748;
  font-size: 20px;
  margin-bottom: 16px;
  text-align: center;
}

.ranking-list {
  list-style: none;
  padding: 0;
}

.ranking-item {
  padding: 12px 16px;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: #4a5568;
}

.logout-section {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 100;
}

.logout-button {
  padding: 8px 16px;
  background-color: #e53e3e;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logout-button:hover {
  background-color: #c53030;
}

.logout-button:active {
  transform: scale(0.98);
}
</style>
